import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'listFilter'
})
export class ListFilterPipe implements PipeTransform {

    transform(names: any[], terms: string, key: string = ''): any[] {
        if (!names) {
            return [];
        }
        if (!terms) {
            return names;
        }
        terms = terms.toLowerCase();
        return names.filter(it => {
            const value = key ? it[key] : it;
        
            if (value == null || typeof value !== 'string') {
                return false;
            }
        
            return value.toLowerCase().includes(terms);
        });
    }

}
